<template>
  <div>
    I am add for sale
  </div>
</template>
<script>
export default {
  name: 'AddPropertyForSale'
}
</script>
